import Guid from "_shared/guids/guid";
import SystemNotification from "notifications/system-notification/system-notification";

export default class SystemNotificationAPIResponse {
  public id?: string;
  public content?: string;

  public constructor(values: Partial<SystemNotificationAPIResponse>) {
    this.id = values.id;
    this.content = values.content;
  }

  public deserialize(): SystemNotification {
    if (!this.id) {
      throw new Error('SystemNotificationAPIResponse.deserialize(): id is required');
    }
    if (!this.content) {
      throw new Error('SystemNotificationAPIResponse.deserialize(): content is required');
    }
    return new SystemNotification(new Guid(this.id), this.content);
  }
}
